export const EMAIL = 'EMAIL';
export const SMS = 'SMS';
export const ZENDESK = 'ZENDESK';
export const ZENDESK_CHAT = 'ZENDESK_CHAT';
export const SALESFORCE = 'SALESFORCE';
export const SALESFORCE_CHAT = 'SALESFORCE_CHAT';
export const SALESFORCE_CHAT_2 = 'SALESFORCE_CHAT_2';
export const DESK = 'DESK';
export const INTERCOM = 'INTERCOM';
export const WEB_CHAT = 'WEB_CHAT';
export const ASYNC_CHAT = 'ASYNC_CHAT';
export const SMS_MESSAGE = 'SMS_MESSAGE';
export const EMAIL_MESSAGE = 'EMAIL_MESSAGE';
export const MESSENGER = 'MESSENGER';
export const GORGIAS = 'GORGIAS';
export const GLADLY = 'GLADLY';
export const GENESYS = 'GENESYS';
export const SIMPLR_CHAT = 'SIMPLR_CHAT';
export const AMAZON_CHAT = 'AMAZON_CHAT';
export const DIRECT_SMS_CHAT = 'SMS';
export const AMAZON_CONNECT = 'AMAZON_CONNECT';
export const TWILIO_VOICE = 'TWILIO_VOICE';

export const validCommunicationType = {
  WEB_CHAT: 'WEB_CHAT',
  ASYNC_CHAT: 'ASYNC_CHAT',
  VOICE_CALL: 'VOICE_CALL',
  EMAIL_MESSAGE: 'EMAIL_MESSAGE',
  SMS_MESSAGE: 'SMS_MESSAGE',
  TWITTER_DM: 'TWITTER_DM',
};

export const isEscalatableClosedTicketType = [ZENDESK_CHAT];

export const channelsWithNoPlatformTicketId = [EMAIL, SMS];

export const LIVE_CHAT_COMMUNICATION_TYPES = [
  validCommunicationType.WEB_CHAT,
  validCommunicationType.ASYNC_CHAT,
  validCommunicationType.SMS_MESSAGE,
];

export const ASYNC_CHAT_COMMUNICATION_TYPES = [validCommunicationType.ASYNC_CHAT, validCommunicationType.SMS_MESSAGE];

export const ESCALATE_TO_SMB_WITH_EMAIL = [ZENDESK_CHAT];

export const communicationTypeFilterItems = [
  { id: 'all', value: 'all', label: 'All' },
  { id: 'chat', value: 'chat', label: 'Chat' },
  { id: 'email', value: 'email', label: 'Email' },
];

// TODO: move to server
export const disabledResolveConversationStates = [
  ZENDESK_CHAT,
  SALESFORCE_CHAT,
  SALESFORCE_CHAT_2,
  SIMPLR_CHAT,
  AMAZON_CHAT,
  AMAZON_CONNECT,
];
